import { createContext, useContext, useState } from 'react'

const SetProgressContext = createContext(() => {})
const GetProgressContext = createContext(null)
const ProgressContextProvider = ({ children, defaultValue = null }) => {
    const [progress, setProgress] = useState(defaultValue)
    return (
        <SetProgressContext.Provider value={setProgress}>
            <GetProgressContext.Provider value={progress}>
                {children}
            </GetProgressContext.Provider>
        </SetProgressContext.Provider>
    )
}

export const useProgress = () => {
    return useContext(GetProgressContext)
}

export const useSetProgress = () => {
    return useContext(SetProgressContext)
}

export default ProgressContextProvider